export default {
  前往查看: '前往查看',
  您的真实姓名: '您的真实姓名',
  申请成为子账号: '申请成为子账号',
  企业联系人: '企业联系人',
  企业管理者联系信息: '企业管理者联系信息',
  企业认证提示1: '完善企业多语言版本,可获取更多外商采购咨询的机会哦！',
  企业名称不能为空: '企业名称不能为空',
  企业名称最多输入120个字符: '企业名称最多输入120个字符',
  请填写企业名称: '请填写企业名称',
  企业认证提示2: '格式为JPG/PNG,建议背景为白色或透明,长宽的尺寸至少大于300px,大小5M以内',
  logo不能为空: 'logo不能为空',
  企业认证提示3: ' 请上传在政府相关机构注册的企业执照,如中国的企业工商营业执照',
  企业营业执照不能为空: '企业营业执照不能为空',
  企业认证提示4: '企业介绍,最多2000个字符数',
  企业简介不能为空: '企业简介不能为空',
  姓名不能为空: '姓名不能为空',
  请填写姓名: '请填写姓名',
  企业认证提示6: '1、手机号最多可输入15个纯数字,固话电话最多可输入20个字符；',
  企业名称最多输入30个字符: '企业名称最多输入30个字符',
  企业简介最多输入2000个字符: '企业简介最多输入2000个字符',
  联系方式不能为空: '联系方式不能为空',
  邮箱不能为空: '邮箱不能为空',
  邮箱格式错误: '邮箱格式错误',
  邮箱最多输入60个字符: '邮箱最多输入60个字符',
  职务最多输入45个字符: '职务最多输入45个字符',
  企业认证提示5:
    '企业管理者,指的是该企业直接负责人,该账号拥有企业的最高管理权限,如企业内容发布、子账号员工管理,企业数据查询等,企业管理人身份不可转交,请谨慎提交申请认证！',
  企业认证提示7: '2、手机号或固定电话可二选一,至少填写其中一个联系方式；',
  企业认证提示8: '我们将尽快为您审核，请审核通过后完善您的企业云展系统',
  企业认证提示9: '您也可以扫码下载官方App或直接打开微信小程序关注更多',
  或点击返回会员中心: '或点击返回会员中心',
  请输入手机号: '请输入手机号',
  请输入固定电话: '请输入固定电话',
  修改图片: '修改图片',
  上传图片: '上传图片',
  文件大小不能超过5M: '文件大小不能超过5M',
  温馨提示: '温馨提示',
  后: '后',
  企业认证申请提示: '企业认证申请提示',
  企业认证提示10: '1、企业角色申请提交成功后,平台将于1-3个工作日进行审核,审核结果会以站内信消息通知,请留意；',
  企业认证提示11:
    '2、企业信息相关内容禁止发布涉及政治、色情、暴力、低俗等违法不良信息,一经发现平台将有权进行冻结您的账户,并保留追究法律责任；',
  企业认证提示12: '3、企业根据面向不同市场与自身所需,可选择补充其他语言版本的翻译内容,支持简体中文（默认）、英语；',
  企业认证提示13:
    '4、云展动力平台支持多语言环境,建议企业在完善企业信息时,同时完善多语言的版本,有助于境外采购商浏览与咨询；',
}
